module.exports = __webpack_public_path__ + "img/news-1.3fc35ea1.png";